<template>
    <div>
<!--        <el-button icon="el-icon-refresh" @click="mRefresh" circle></el-button>-->
        <div v-loading="loading" :element-loading-text="loadingText">
            <vue-qr :text="url" :logoSrc="logoSrc" :callback="initQrCode" :size="size"></vue-qr>
        </div>
    </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
    name: "qr-code",
    components: { VueQr },
    props: {
        url: { type: String, required: true, },
        callback: { type: Function, required: true },
        logoSrc: { type: String, default: "" },
        size: { type: Number, default: 200 },
        loadingText: { type: String, default: "" },
        loading: { type: Boolean, default: false },
        refresh: { type: Function, default: undefined }
    },
    methods: {
        initQrCode(dataUrl, id) { this.callback(dataUrl, id) },
        mRefresh() {
            if (this.refresh) { this.refresh() }
        }
    },
    mounted() {
        console.log(this.url);
    },
}
</script>
<style scoped>
.refresh-btn {
    margin-top: 200px;
    /* width: 4%;
    height: 10%;
    overflow: auto;
    margin: auto; */
    position: fixed;
    /* top: 0;
    left: 0;
    bottom: 0;
    right: 0; */
    z-index: 9999;
}
</style>
